package com.xtream.ui.ui.widget

import androidx.compose.runtime.Composable

@Composable
actual fun ConfigureDialogWindowProperties() {
}